// extracted by mini-css-extract-plugin
module.exports = {"loader":"theme_loader__1UB8o"};